import { render } from "./SectionHeader.vue?vue&type=template&id=a6c374ce&scoped=true&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=a6c374ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c374ce"]])

export default __exports__